export default {
    CLASS: 'learning-component-class',
    IMAGE_CLASS: 'learning-component-image-class',
    TEXT_BOX_CLASS: 'learning-component-textbox-class',

};